import type { ProgramNewsRun } from "@/services/adminProgramNews";
import { formatUsd } from "./formatters";

export const COST_WARN_USD = 25;
export const COST_STOP_USD = 50;

interface RunCostLineProps {
  /** The most recent classify run, or null when none has run. */
  run: ProgramNewsRun | null;
}

const THRESHOLDS = `warns at $${COST_WARN_USD}/month, stops at $${COST_STOP_USD}/month`;

const RunCostLine = ({ run }: RunCostLineProps) => {
  const counters = run?.counters;
  const projected = counters?.projectedMonthlyUsd;
  const overStop = typeof projected === "number" && projected >= COST_STOP_USD;
  const overWarn = typeof projected === "number" && projected >= COST_WARN_USD;

  return (
    <p className="text-sm text-muted-foreground" data-testid="run-cost-line">
      {run ? (
        <>
          <span className="font-medium text-foreground">
            Latest classification cost {formatUsd(counters?.costUsd)}
          </span>
          {" · "}
          <span className={overStop ? "text-destructive" : overWarn ? "text-amber-700" : undefined}>
            projected {formatUsd(projected)}/month
          </span>
          {counters?.stoppedForCost ? (
            <span className="text-destructive"> · stopped for cost</span>
          ) : null}
        </>
      ) : (
        <span>No classification run yet</span>
      )}
      {" · "}
      {THRESHOLDS}
    </p>
  );
};

export default RunCostLine;
